'use strict';

$(function () {
    var $countryLabel = $('#countryLabel');
    var $countrySelect = $('#deliveryCountry');

    function updateCountryLabelAndTable() {
        var selected = $countrySelect.val();
        var selectedText = $countrySelect.find('option:selected').text();
        var countryTemplate = $countryLabel.data('country');
        $countryLabel.text(countryTemplate.replace('{0}', selectedText));
        $('[id^="deliveryTable-"]').addClass('d-none');

        var $selectedTable = $('#deliveryTable-' + selected);
        if ($selectedTable.length) {
            $selectedTable.removeClass('d-none');
        }
    }

    $countrySelect.on('change', updateCountryLabelAndTable);
});